import { ReactNode } from 'react';

import { FlagSyncLogo } from '@/components/svgs/logo';
import { Card, CardContent } from '@/components/ui/card';
import { TypographyH4, TypographyMuted } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

interface AuthTemplateProps {
  heading?: ReactNode;
  subheading?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export const AuthTemplate = ({
  heading,
  subheading,
  children,
  footer,
  className,
}: AuthTemplateProps) => {
  return (
    <div
      className={cn('sm:mx-auto sm:w-full sm:max-w-lg space-y-2', className)}
    >
      <Card className="w-full">
        <CardContent className="px-6 flex flex-col space-y-6">
          <div className="flex flex-col space-y-2">
            <div className="flex justify-between items-center">
              <TypographyH4>{heading}</TypographyH4>
              <span className="place-items-end">
                <FlagSyncLogo className="h-5" />
              </span>
            </div>
            {subheading && (
              <TypographyMuted as="div">{subheading}</TypographyMuted>
            )}
          </div>
          {children}
        </CardContent>
      </Card>
      <div className="pl-2 pt-2">{footer}</div>
    </div>
  );
};
